import { endpoint, env, getAuthToken, handleUnauthorized } from '@eruvaka/web-pondlogs-base';
const api = (path) => endpoint(env.apiBaseUrl, path);
const authFetch = async (url, options = {}) => {
    const token = getAuthToken();
    return fetch(url, {
        ...options,
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
    });
};
const handleError = async (res, fallback) => {
    if (res.status === 401) {
        handleUnauthorized();
        throw new Error('Unauthorized');
    }
    let message = fallback;
    try {
        const body = (await res.json());
        message = body.message ?? body.error ?? fallback;
    }
    catch {
        /* ignore */
    }
    throw new Error(message);
};
export const fetchLocations = async () => {
    const res = await authFetch(api('/api/v3/locations'));
    if (!res.ok)
        return handleError(res, 'Failed to fetch locations');
    const body = (await res.json());
    return body.data;
};
export const fetchLocation = async (locationId) => {
    const res = await authFetch(api(`/api/v3/locations/${locationId}`));
    if (!res.ok)
        return handleError(res, 'Failed to fetch location');
    const body = (await res.json());
    return body.data;
};
export const createLocation = async (payload) => {
    const res = await authFetch(api('/api/v3/locations'), {
        method: 'POST',
        body: JSON.stringify(payload),
    });
    if (!res.ok)
        return handleError(res, 'Failed to create location');
    const body = (await res.json());
    return body.data;
};
export const updateLocation = async (locationId, payload) => {
    const res = await authFetch(api(`/api/v3/locations/${locationId}`), {
        method: 'PUT',
        body: JSON.stringify(payload),
    });
    if (!res.ok)
        return handleError(res, 'Failed to update location');
    const body = (await res.json());
    return body.data;
};
export const deleteLocation = async (locationId) => {
    const res = await authFetch(api(`/api/v3/locations/${locationId}`), { method: 'DELETE' });
    if (!res.ok)
        return handleError(res, 'Failed to delete location');
};
